import { Reducer } from 'redux';

import { ConfigState } from './types';

const defaultState: ConfigState = {
    drawerMenuFolded: false,
    bootedAsChild: false,
    isStandalone: true,
};

const reducer: Reducer<ConfigState> = (state: ConfigState = defaultState, action): ConfigState => {
    const { type, payload } = action;

    switch (type) {
        case '@@config/CHANGE_MENU_STATE':
            return { ...state, ...{ drawerMenuFolded: payload.drawerMenuFolded } };
        case '@@config/CHANGE_ROUTER_BASE_PATH':
            return { ...state, ...{ routerBasePath: payload.routerBasePath } };
        case '@@config/CHANGE_IS_STANDLONE':
            return { ...state, ...{ isStandalone: payload.isStandalone } };
        case '@@config/SET_RTL':
            return { ...state, ...{ isRtl: payload.isRtl } };
        case '@@config/SET_BOOTED_AS_CHILD':
            return { ...state, ...{ bootedAsChild: payload.isBootedAsChild } };
        default:
            return state;
    }
};

export { reducer as config };

export default reducer;
